module.exports = require("core-js-pure/features/object/get-own-property-symbols");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs3/core-js/object/get-own-property-symbols.js
// module id = 619
// module chunks = 0